//GiftsToMe.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faEye } from '@fortawesome/free-solid-svg-icons';

const MyOrders = () => {
    const authState = useSelector(state => state.authReducer);
    const redeemedBy = authState.user._id;
    const [fetchData, { loading }] = useFetch();

    const [giftsToMe, setGiftsToMe] = useState([]);
    const [selectedGiftsToMeId, setSelectedGiftsToMeId] = useState('');

    //GiftsToMeList
    const fetchGiftsToMeList = useCallback(() => {
        const config = {
            url: "/giftcoupon/byreceiver",
            method: "post",
            headers: { Authorization: authState.token },
            data: {redeemedBy: redeemedBy}
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.giftCoupons)) {
                    setGiftsToMe(response.giftCoupons);
                }  else {
                    console.error("Invalid response format: expected array or object");
                }
            })
            .catch(error => {
                console.error("Error fetching gifted coupons:", error);
            });
        
    }, [authState.token, fetchData, redeemedBy]);

    useEffect(() => {
        fetchGiftsToMeList();
    }, [fetchGiftsToMeList]);

    const handleGiftsToMeDescView = (itemId) => {
        setSelectedGiftsToMeId(prevId => (prevId === itemId ? null : itemId));
    };

    const sortedGiftsToMe = giftsToMe.sort((a, b) => {
        const dateA = new Date(a.dateCreated);
        const dateB = new Date(b.dateCreated);
        return dateB - dateA;
    });

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };


    return (
        <MainLayout>
            <div className="mx-auto px-4 py-8 mt-12">
                <div className="list-container border border-gray-500 rounded-lg shadow-lg p-6 bg-gray-700">
                    {loading ? (
                        <Loader />
                    ) : (
                        <div>
                            <h2 className="text-3xl font-bold text-white mb-6 flex items-center">
                                <FontAwesomeIcon icon={faGift} className="text-red-500 text-4xl mr-4" />
                                My Orders
                            </h2>
                            <div>
                                {giftsToMe && giftsToMe.length === 0 ? (
                                    <div className='w-full h-64 flex items-center justify-center text-yellow-400'>
                                        No records found!
                                    </div>
                                ) : (
                                    sortedGiftsToMe.map((giftstome, index) => (
                                        <div key={giftstome._id} className='bg-gray-800 my-4 p-6 text-gray-100 rounded-lg shadow-lg transition-transform transform hover:scale-105'>
                                            <div className='flex items-center mb-4'>
                                                <span className='font-medium text-lg'>{index + 1}. {giftstome.gifterName} has gifted to me - </span>
                                            </div>
                                            <div className='flex items-center mb-4'>
                                                <span className='font-medium text-blue-300 text-lg'>{giftstome.bookTitle}</span>
                                                <Tooltip text={"View details"} position={"top"}>
                                                    <span className='ml-auto text-blue-400 cursor-pointer hover:text-blue-300' onClick={() => handleGiftsToMeDescView(giftstome._id)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                            {selectedGiftsToMeId === giftstome._id && (
                                                <div className='bg-gray-700 text-gray-200 mt-4 p-6 rounded-lg border border-gray-600'>
                                                    <h2 className='text-blue-400 text-xl font-semibold mb-3'>{giftstome.bookTitle}</h2>
                                                    <p><strong>Name:</strong> {giftstome.gifterName}</p>
                                                    <p><strong>Date:</strong> {new Date(giftstome.dateCreated).toLocaleDateString()}</p>
                                                </div>
                                            )}
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </MainLayout>
    );
};

export default MyOrders;


